<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <ul class="nav nav-tabs bg-white border-0 rounded-0" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100 active"
            id="edit-user-tab"
            data-bs-toggle="tab"
            data-bs-target="#edit-user-tab-pane"
            type="button"
            role="tab"
            aria-selected="true"
          >
            Informations
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100"
            id="permission-tab"
            data-bs-toggle="tab"
            data-bs-target="#permission-tab-pane"
            type="button"
            role="tab"
            aria-selected="false"
          >
            Permissions
            <span v-if="totalEnabled > 0" class="badge bg-success ms-1" style="font-size:0.65rem">
              {{ totalEnabled }}
            </span>
          </button>
        </li>
      </ul>

      <div class="tab-content p-15 p-sm-20 p-md-25 p-lg-30" id="myTabContent">

        <!-- ── Tab 1: User Info ───────────────────────────────────── -->
        <div class="tab-pane fade show active" id="edit-user-tab-pane" role="tabpanel" tabindex="0">
          <form @submit.prevent="handleSubmit">
            <div class="row">
              <div class="col-md-12 mb-20">
                <label class="d-block text-black fw-semibold mb-10">Photo de profil</label>
                <div class="d-flex align-items-center gap-3">
                  <img
                    :src="imagepreview || require('@/assets/images/NoImage.png')"
                    class="rounded-circle"
                    style="width: 80px; height: 80px; object-fit: cover; border: 2px solid #e9ecef"
                  />
                  <div class="d-flex gap-2">
                    <input ref="updateImgInput" type="file" accept="image/*" class="d-none" @change="logoSelected" />
                    <button type="button" class="btn btn-outline-primary btn-sm" @click="() => updateImgInput?.click()">
                      Choisir
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="cancelImage">
                      Annuler
                    </button>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10">Nom complet *</label>
                <input v-model="userData.name" type="text" class="form-control shadow-none rounded-0" placeholder="Nom complet" required />
              </div>

              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10">Téléphone *</label>
                <input v-model="userData.phone" type="text" pattern="^0[0-9]{9}$" class="form-control shadow-none rounded-0" placeholder="0XXXXXXXXX" required />
              </div>

              <div class="col-md-12 mb-20">
                <label class="d-block text-black fw-semibold mb-10">Email *</label>
                <input v-model="userData.email" type="email" class="form-control shadow-none rounded-0" placeholder="exemple@email.com" required />
              </div>

              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10">Mot de passe *</label>
                <input v-model="userData.password" type="password" class="form-control shadow-none rounded-0" placeholder="••••••••" required />
              </div>

              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10">Confirmation *</label>
                <input v-model="userData.c_password" type="password" class="form-control shadow-none rounded-0" placeholder="••••••••" required />
              </div>

              <div class="col-md-12 d-flex align-items-center justify-content-between mt-10">
                <button type="submit" class="btn btn-success px-4" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  Enregistrer
                </button>
                <router-link to="/users-list" class="btn btn-link text-danger">Annuler</router-link>
              </div>
            </div>
          </form>
        </div>

        <!-- ── Tab 2: Permissions ─────────────────────────────────── -->
        <div class="tab-pane fade" id="permission-tab-pane" role="tabpanel" tabindex="0">

          <!-- Header bar -->
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div>
              <div class="fw-bold text-dark fs-15">Permissions d'accès</div>
              <div class="text-muted small mt-1">
                <span class="fw-semibold text-success">{{ totalEnabled }}</span>
                / {{ permissionsData.length }} activées
              </div>
            </div>
            <div class="d-flex align-items-center gap-2">
              <!-- Enable all / Disable all -->
              <button
                type="button"
                class="btn btn-sm btn-outline-success"
                @click="enableAll"
                :disabled="totalEnabled === permissionsData.length"
              >
                Tout activer
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                @click="disableAll"
                :disabled="totalEnabled === 0"
              >
                Tout désactiver
              </button>
              <button class="btn btn-primary btn-sm px-4" @click="AddPerms" :disabled="load">
                <span v-if="load" class="spinner-border spinner-border-sm me-2"></span>
                Enregistrer
              </button>
            </div>
          </div>

          <!-- Loading state -->
          <div v-if="permsLoading" class="text-center py-5 text-muted">
            <div class="spinner-border spinner-border-sm me-2"></div>
            Chargement...
          </div>

          <!-- Permission list -->
          <div v-else-if="permissionsData.length" class="perm-list">
            <div
              v-for="perm in permissionsData"
              :key="perm.id"
              class="perm-item d-flex align-items-center justify-content-between"
              :class="{ 'perm-item--on': perm.checked }"
              @click="perm.checked = !perm.checked"
            >
              <div class="d-flex align-items-center gap-3">
                <div class="perm-dot" :class="perm.checked ? 'perm-dot--on' : ''"></div>
                <span class="fw-medium text-dark small">{{ perm.name }}</span>
              </div>
              <div class="form-check form-switch mb-0" @click.stop>
                <input
                  v-model="perm.checked"
                  class="form-check-input"
                  type="checkbox"
                  style="cursor:pointer; width:2.2em; height:1.1em"
                />
              </div>
            </div>
          </div>

          <!-- Empty state -->
          <div v-else class="text-center py-5 text-muted small">
            Aucune permission disponible.
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import { computed, reactive, defineComponent, onMounted, ref } from "vue";

interface Permission {
  id: number;
  code: string | null;
  name: string;
  checked: boolean;
}

export default defineComponent({
  name: "EditUser",
  props: {
    userId: { type: String, required: true },
  },
  setup(props) {
    const { showToast } = useAppToast();

    const updateImgInput = ref<HTMLInputElement | null>(null);
    const imagepreview = ref<string | null>(null);
    const loading = ref(false);
    const load = ref(false);
    const permsLoading = ref(false);
    const userData = reactive<Record<string, any>>({});
    const permissionsData = ref<Permission[]>([]);

    // ── Computed ────────────────────────────────────────────────────
    const totalEnabled = computed(() => permissionsData.value.filter((p) => p.checked).length);

    // ── Lifecycle ───────────────────────────────────────────────────
    onMounted(() => {
      getUser();
      getPerms();
    });

    // ── Image ───────────────────────────────────────────────────────
    const logoSelected = (e: Event) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (file) imagepreview.value = URL.createObjectURL(file);
    };
    const cancelImage = () => {
      imagepreview.value = null;
      if (updateImgInput.value) updateImgInput.value.value = "";
    };

    // ── User info ───────────────────────────────────────────────────
    const handleSubmit = async () => {
      if (!userData.name || !userData.email) {
        showToast("Veuillez remplir tous les champs obligatoires", "error");
        return;
      }
      loading.value = true;
      const formData = new FormData();
      formData.append("name", userData.name);
      formData.append("phone", userData.phone ?? "");
      formData.append("email", userData.email);
      formData.append("password", userData.password ?? "");
      formData.append("c_password", userData.c_password ?? "");
      formData.append("custUserId", userData.id);
      if (updateImgInput.value?.files?.[0]) {
        formData.append("image", updateImgInput.value.files[0]);
      }
      try {
        const res = await api.post(
          `/api/auth/client/EditActiveCustomerUser/${props.userId}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        if (res.data.msg === "success") showToast("Utilisateur modifié avec succès", "success");
        else if (res.data.msg === "email exist") showToast("Cet email est déjà utilisé", "error");
        else if (res.data.msg === "no customer") showToast("Accès non autorisé", "error");
        else if (res.data.msg === "no user") showToast("Utilisateur non trouvé", "error");
        else showToast("Erreur lors de la modification", "error");
      } catch {
        showToast("Erreur serveur, réessayez plus tard", "error");
      } finally {
        loading.value = false;
      }
    };

    const getUser = async () => {
      try {
        const res = await api.get(`/api/auth/client/user_account/${props.userId}`);
        if (res?.data?.data) {
          Object.assign(userData, res.data.data);
          imagepreview.value = res.data.data.image || null;
        }
      } catch (e) {
        console.error("getUser error:", e);
      }
    };

    // ── Permissions ─────────────────────────────────────────────────
    // API returns: { msg: "success", data: [{id, code, name, checked}, ...] }
    async function getPerms() {
      permsLoading.value = true;
      try {
        const res = await api.get(`/api/auth/client/permissions_user/${props.userId}`);
        permissionsData.value = Array.isArray(res.data?.data) ? res.data.data : [];
      } catch (e) {
        console.error("getPerms error:", e);
      } finally {
        permsLoading.value = false;
      }
    }

    // API expects: perms = JSON flat array [{id, name, checked}]
    async function AddPerms() {
      try {
        load.value = true;

        const flatPerms = permissionsData.value.map((p) => ({
          id: p.id,
          name: p.name,
          checked: p.checked,
        }));

        const data = new FormData();
        data.append("perms", JSON.stringify(flatPerms));
        data.append("cust_user_id", props.userId);

        const res = await api.post(`/api/auth/client/edit_perms_user`, data);

        if (res.data.success) {
          showToast("Permissions mises à jour avec succès", "success");
          getPerms();
        } else if (res.data.msg === "no user") {
          showToast("Utilisateur non trouvé", "error");
        } else if (res.data.msg === "no customer") {
          showToast("Accès non autorisé", "error");
        } else {
          showToast("Erreur inattendue, réessayez plus tard", "error");
        }
      } catch (e) {
        console.error("AddPerms error:", e);
        showToast("Erreur serveur, réessayez plus tard", "error");
      } finally {
        load.value = false;
      }
    }

    function enableAll() {
      permissionsData.value.forEach((p) => (p.checked = true));
    }

    function disableAll() {
      permissionsData.value.forEach((p) => (p.checked = false));
    }

    return {
      updateImgInput, imagepreview, loading, load, permsLoading,
      userData, permissionsData, totalEnabled,
      logoSelected, cancelImage,
      handleSubmit, getUser,
      getPerms, AddPerms,
      enableAll, disableAll,
    };
  },
});
</script>

<style scoped>
/* ── Permission list ───────────────────────────────────────────────── */
.perm-list {
  border: 1px solid #e9ecef;
  border-radius: 10px;
  overflow: hidden;
}

.perm-item {
  padding: 13px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f1f3f5;
  transition: background 0.15s;
  background: #fff;
}
.perm-item:last-child { border-bottom: none; }
.perm-item:hover { background: #f8f9fa; }
.perm-item--on { background: #f6fdf9; }
.perm-item--on:hover { background: #edfaf4; }

/* ── Status dot ────────────────────────────────────────────────────── */
.perm-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #dee2e6;
  flex-shrink: 0;
  transition: background 0.2s;
}
.perm-dot--on { background: #198754; }
</style>
